import React from "react";
import { View, StyleSheet } from "react-native";

import { Button, Icon, Text } from "components";

import { sizes, colors, strings } from "assets/constants";
import { factorItemsAtom } from "stores";
import { useRecoilValue } from "recoil";
import { priceFormatter } from "utils";
import tinycolor from "tinycolor2";
import { useFlag } from "hooks";

type PropsT = {
  lastUpdate?: string;
  factorDescription?: string;
};

const FactorInfo: React.FC<PropsT> = (props) => {
  const { lastUpdate, factorDescription } = props;
  const { flg: desc, on: showDesc, off: hideDesc } = useFlag();

  const factorItems = useRecoilValue(factorItemsAtom);

  return (
    <>
      <View style={styles.container}>
        <View
          style={{
            paddingVertical: 3,
            paddingHorizontal: 5,
            backgroundColor: tinycolor(colors.theme).lighten(51).toString(),
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text size={"xs"}> {strings.currency}</Text>
          <Text weight="extraBold" color={colors.theme}>
            {priceFormatter(
              factorItems?.reduce(
                (sum, a) => (a?.total_price ? +a.total_price + sum : sum),
                0
              )
            )}{" "}
          </Text>
          <Text weight="bold" size={"sm"} color={colors.text.gray}>
            {strings.total_factor_amount}:
          </Text>
        </View>

        <View>
          {lastUpdate && (
            <>
              <Text top={2} size={"xs"} color={colors.text.gray}>
                {strings.latest_update}
              </Text>

              <Text top={-2} weight="bold" color={colors.theme}>
                {lastUpdate}
              </Text>
            </>
          )}
        </View>
      </View>

      {factorDescription && (
        <View style={{ minHeight: 40 }}>
          {desc ? (
            <View
              style={{ padding: sizes?.space, backgroundColor: colors.white }}
            >
              <Text weight="bold">{factorDescription}</Text>

              <Button
                onPress={hideDesc}
                top={8}
                left={5}
                absolute
                circle={30}
                icon={{ name: "eye-off", color: colors.danger }}
                bgColor={colors.transparent}
              />
            </View>
          ) : (
            <Button
              onPress={showDesc}
              bgColor={colors.transparent}
              height={32}
              width={"auto"}
              title={{
                size: "sm",
                color: colors.info,
                weight: "bold",
                value: "مشاهده توضیحات سفارش",
              }}
              icon={{ name: "eye" }}
              style={{ alignSelf: "flex-end", marginHorizontal: sizes?.space }}
              contentSeparator={3}
            />
          )}
        </View>
      )}
    </>
  );
};

export default FactorInfo;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: sizes.space,
    backgroundColor: colors.white,
    marginVertical: sizes.space / 2,
    paddingRight: sizes.space,
    marginTop: 4,
    height: 40,
    alignItems: "center",
  },
});
